import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classnamesBind from "classnames/bind";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import { getFeature } from "../../utils/features";
import { useFeaturesReady } from "../../context/featuresReady/FeaturesReadyContext";
import styles from "./ReviewsSummary.scss";

const classnames = classnamesBind.bind(styles);

const ReviewsSummary = ({ reviewsSummary = null, additionalClasses = "" }) => {
  const { getTranslation } = useRuntimeConstants();
  const { areFeaturesReady } = useFeaturesReady();
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    if (!areFeaturesReady || reviewsSummary === null) return;

    setIsEnabled(getFeature("pdp-review-summary").isEnabled());
  }, [areFeaturesReady, reviewsSummary]);

  if (!isEnabled || reviewsSummary === null) {
    return null;
  }

  const { disclaimer, summary } = reviewsSummary || {};

  return (
    <div
      className={classnames(styles.wrapper, additionalClasses)}
      data-testid="reviews-summary"
    >
      <h3 className={styles.title}>
        {getTranslation("pdp_ratings_reviews_review_summary_title")}
      </h3>
      <div className={styles.disclaimerWrapper}>
        <span
          className={classnames(
            styles.disclaimerIcon,
            "product-ai-summary-icon"
          )}
        ></span>
        <p className={styles.disclaimer}>{disclaimer}</p>
      </div>
      <p className={styles.summary}>{summary}</p>
    </div>
  );
};

ReviewsSummary.propTypes = {
  reviewsSummary: PropTypes.oneOfType([
    PropTypes.shape({
      disclaimer: PropTypes.string.isRequired,
      summary: PropTypes.string.isRequired,
    }),
    PropTypes.oneOf([undefined, null]),
  ]),
  additionalClasses: PropTypes.string,
};

export default ReviewsSummary;
